<template>
  <modal :show-close="modalConfig.showClose"
         :wrapper-classes="modalConfig.wrapperClasses"
         @close="closeModal()">
    <h2 slot="header" class="modal-title text-3xl text-center sm:text-4xl mt-5 sm:mt-10">
      target wallet
    </h2>
    <h4 slot="subHeader" class="text-xs text-gray-700 text-center font-light px-0 sm:px-10 sm:text-xl">
      select a target wallet link to direct your members to a specific destination in their loyalty wallet
    </h4>
    <target-wallet-form
      slot="body"
      class="body"
      :targetWalletDraftState.sync="targetWalletDraftState"
    />
    <div slot="action" class="modal-action-click">
      <button class="button done-button" :disabled="isDoneButtonDisabled" @click="clickedDone()" data-cy="target-wallet-done-button">done</button>
    </div>
  </modal>
</template>

<script>
import _ from "lodash";
import Modal from "../../../shared/Modal.vue";
import TargetWalletForm from "../forms/target-wallet-form.vue";

export default {
  props: {
    extension: Object
  },

  name: "target-wallet-modal",

  components: {Modal, TargetWalletForm},

  data() {
    return {
      modalConfig: {
        showClose: true,
        wrapperClasses: ["extensions-modal","target-wallet-modal"]
      },
      targetWalletDraftState: null
    }
  },

  created() {
    this.targetWalletDraftState = _.cloneDeep(this.extension.payload);
  },

  computed: {
    isDoneButtonDisabled() {
      return !this.targetWalletDraftState || !this.targetWalletDraftState.target_wallet;
    }
  },

  methods: {
    async clickedDone(){
      this.$emit("update:campaign",{ _type_options: this.targetWalletDraftState.target_wallet })
      this.extension.payload = this.targetWalletDraftState;
      this.$emit("closeModal");
    },

    closeModal() {
      this.$emit("closeModal");
    },
  },
}
</script>

<style scoped>
.target-wallet-modal {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
  width: 100%;
}

.target-wallet-modal .body {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.target-wallet-modal >>> .row {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 21px;
  min-width: 140px;
}

.target-wallet-modal >>> .row .sb-checkbox {
  margin-right: 15px;
  width: 16px;
  height: 16px;
  border: 1px solid #128ff9;
}

.done-button {
  min-width: 10rem;
  top: 1rem !important;
}
</style>
